import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import dropin from 'braintree-web-drop-in';
import { Modal, Button } from 'react-bootstrap';
import pathObj from '../../services/Config';
import { CommonService } from '../../services/common';
import toast from 'react-hot-toast';
import getSymbolFromCurrency from 'currency-symbol-map';
import { decryptData, errorHandling, UpdatedDecimalDigits } from '../../helpers/common';
import md5 from "md5";


const BraintreePaymentModal = ({ show, hide, selectedInvoices, selectedInvoicesAmount, customerId, reset, setSelectedInvoices, setTotalDebit, setSelectedInvoicesAmount, setTotalCredit }) => {
  
  const [clientToken, setClientToken] = useState(null);
  const [braintreeInstance, setBraintreeInstance] = useState(null);
  const [paymentProcessing, setPaymentProcessing] = useState(false);
  const dropinContainerRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const userInfo = window.localStorage.getItem('userData');
  const userD = decryptData(userInfo);
  const compData = JSON.parse(userD);
  const currencyName = compData?.Currency
  const currencySymbol = getSymbolFromCurrency(currencyName);
  const token = localStorage.getItem("Token");
  const [paymentDatewaySettings, setPaymentDatewaySettings] = useState([]);
  // Fetch Braintree token from the Laravel backend
  useEffect(() => {
    const fetchBraintreeToken = async () => {
      try {
        const token = localStorage.getItem('Token'); // Get token from localStorage if needed
        const response = await axios.get(`${pathObj?.baseURL}${pathObj?.brainTreeToken}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });
        setClientToken(response.data.token);
      } catch (error) {
        console.error('Error fetching Braintree token:', error);
      }
    };
    fetchBraintreeToken();
  }, []);

  // Initialize Braintree Drop-In UI when modal is opened and token is available
  useEffect(() => {
    if (show && clientToken && dropinContainerRef.current) {
      dropin.create({
        authorization: clientToken,
        container: dropinContainerRef.current,
      }, (error, instance) => {
        if (error) {
          console.error('Braintree Drop-In error:', error);
        } else {
          setBraintreeInstance(instance);
        }
      });
    }
  }, [show, clientToken]);

  const createOrderPayload = (selectedInvoices, customerId) => {
        // Build the payload
        return {
            customer_id: customerId,
            amount: selectedInvoicesAmount,
            doc_entry: selectedInvoices,
        };
    };

  const handlePayment = async () => {
      setLoading(true);

      try {              
          const payload = createOrderPayload(selectedInvoices, customerId);              
          let paymentSuccess = false;
          
          // if (payTermsGrp === 17 || payTermsGrp !== 17) {                  
              // try {
              //     const paymentResponse = await axios.post(`${pathObj.baseURL}${pathObj.balancesheetPayment}`, {
              //         ...payload,
              //     }, {
              //         headers: {
              //             'Content-Type': 'application/json',
              //             'Authorization': `Bearer ${token}`
              //         }
              //     });
                  
              //     if (paymentResponse?.data?.success) {

                        // If selectedInvoices is empty, generate a default cartId and MC_myText
                        // console.log('------------------------------', selectedInvoices);
                        const selectedInvoiceId = typeof selectedInvoices === 'string' && selectedInvoices.trim() !== ''
                          ? selectedInvoices.trim() : '';
                        // console.log('test------------------------------', String(selectedInvoiceId));
                        const hasSelectedInvoices = selectedInvoiceId && selectedInvoiceId.trim() !== '';

                        const defaultCartId = 'ORD12345';
                        const cartIdValue = hasSelectedInvoices ? selectedInvoiceId : defaultCartId;
                        const mcMyTextValue = hasSelectedInvoices ? selectedInvoiceId : defaultCartId;
                        // console.log('cartIdValue------------------------------', cartIdValue);
                        // console.log('mcMyTextValue------------------------------', mcMyTextValue);


                        const formData = {
                          testMode: process.env?.REACT_APP_WORLDPAY_PAYMENT_MODE || pathObj.worldpayPaymentMode, // 100 for test mode
                          instId: process.env?.REACT_APP_WORLDPAY_INST_ID || pathObj.worldpayInstId, // Worldpay institution ID
                          cartId: cartIdValue, 
                          amount: payload?.amount, 
                          currency: currencyName, 
                          MC_myText: mcMyTextValue,
                          MC_myCs: customerId,
                          MC_orderType: 'OUTSTANDING',
                          MC_callback: `${pathObj.baseURL}${pathObj.worldpayCallback}`,
                          MC_returnurl: `${pathObj.frontUrl}/account-balance/thank-you`, 
                          MC_cancelurl: `${pathObj.frontUrl}/account-balance`,
                          signature: md5(`${process.env?.REACT_APP_WORLDPAY_PASSWORD || pathObj.worldpayPassword}:${currencyName}:${payload?.amount}:${process.env?.REACT_APP_WORLDPAY_INST_ID || pathObj.worldpayInstId}`),
                          signatureField: `${currencyName}:${payload?.amount}:${process.env?.REACT_APP_WORLDPAY_INST_ID || pathObj.worldpayInstId}`,
                          password: process.env?.REACT_APP_WORLDPAY_PASSWORD || pathObj.worldpayPassword,
                        };
                      
                      const form = document.createElement('form');
                      form.action = process.env?.REACT_APP_WORLD_PAYMENT_URL;
                      form.method = 'POST';

                      Object.keys(formData).forEach((key) => {
                      const input = document.createElement('input');
                      input.type = 'hidden';
                      input.name = key;
                      input.value = formData[key];
                      form.appendChild(input);
                      });
                      document.body.appendChild(form);
                      form.submit();

                  // } else {
                  //     toast.error(paymentResponse.data.message || 'Payment failed. Please try again.');
                  //     setLoading(false);
                  // }
              // } catch (paymentError) {
              //     toast.error(paymentError?.response?.data?.message || paymentError?.message || 'Payment failed.');
              //     setLoading(false);
              //     errorHandling(paymentError);
              // }
          // }
      } catch (error) {
          toast.error(error?.response?.data?.data?.delivery_option?.[0] || error?.message || 'Failed to process the payment. Please check the required fields.');
          setLoading(false);
          errorHandling(error);
      }
  };

  return (
    <>

      <Modal show={show} onHide={hide} centered>
        <Modal.Header closeButton>
          <Modal.Title>Complete Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="form-check custom_check">
          <label className="form-check-label" htmlFor="selectedInvoices">
            Pay Selected invoices: {currencySymbol}
          </label>
          <input
            type="text"
            value={selectedInvoicesAmount.toFixed(2)}
            className="form-control"
            readOnly
          />
        </div> */}
          <span> Pay Selected invoices: <strong>{currencySymbol}{UpdatedDecimalDigits(selectedInvoicesAmount)}</strong> </span>
          {/* Braintree Drop-In UI Container */}
          {/* <div ref={dropinContainerRef}></div>
          {paymentProcessing && (<div className='loaderOuter'><div className="loader"></div></div>)} */}
          {/* {paymentProcessing && <p>Processing payment, please wait...</p>} */}

        </Modal.Body>
        <Modal.Footer>
          <div class="btn_row pb-1">
            {/* <a class="button2" onClick={hide}>Close</a> */}
            <a class="button2" onClick={handlePayment}>Proceed To Payment</a>
          </div>
          {/* <Button className='button2' onClick={hide}>Close</Button>
        <Button
          className='button2'
          onClick={handlePayment}
          disabled={!braintreeInstance || paymentProcessing}
        >
          {paymentProcessing ? 'Processing...' : 'Confirm Payment'}
        </Button> */}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BraintreePaymentModal;
